module.exports = __webpack_public_path__ + "img/add-off.32a0c20b.svg";